import React from "react";
import HeaderTwo from "../HeaderTwo/Main";
import BannerTwo from "../Menhometwo/BannerTwo";
import PatnerOne from "../Menhometwo/PatnerOne";
import FeaturesTwo from "../Menhometwo/FeaturesTwo";
import FeaturesThree from "../Menhometwo/FeaturesThree";
import ServiceTwo from "../Menhometwo/ServiceTwo";
import FactOne from "../Menhometwo/FactOne";
import CaseOne from "../Menhometwo/CaseOne";
import TestimonialTwo from "../Menhometwo/TestimonialTwo";
import CtaTwo from "../Menhometwo/CtaTwo";
import FooterTwo from "../FooterTwo/Main";


function Main() {
  return (
    <div>
      <HeaderTwo />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper page-wrapper-two">
            <main>
              <BannerTwo />
              <PatnerOne />
              <FeaturesTwo />
              <FeaturesThree />
              <ServiceTwo />
              <FactOne />
              <CaseOne />
              <TestimonialTwo />
              <CtaTwo />
            </main>
            <FooterTwo />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
